import tracer from "dd-trace";
import { isTraceableEnvironment } from "./is-traceable-environment";
export var getTraceId = function() {
    var ref;
    return isTraceableEnvironment() ? (ref = tracer.scope().active()) === null || ref === void 0 ? void 0 : ref.context().toTraceId() : "";
};
